export const fastCasinoSoftwareTextContent = {
  headingText: (
    <>
      <span>Custom, Turnkey &</span>{" "}
      <span>White Label Fast Casino Software</span>
    </>
  ),
  paraText:
    "Build from ground up or launch in no time with our custom, white label and turnkey fast casino software offerings. Our custom fast-casino game website allows you to build your vision while white label and turnkey fast-casino game software solutions get ready for deployment within a handful of weeks. Our turnkey fast casino game development services and our custom fast casino game development also support 3rd party integrations. Harness the power of our feature-rich Fast-casino game apps and give a powerful boost to your overall revenue.",
  btnText: "Hire Fast Casino Game Developers",
};
